export const teacherMessages = {
    "countries.CA": "Canada (excludes Québec)",
    "birthDate": "Birth Date",
    "companyName": null,
    "dateTime": {
        "january": "January",
        "february": "February",
        "march": "March",
        "april": "April",
        "may": "May",
        "june": "June",
        "july": "July",
        "august": "August",
        "september": "September",
        "october": "October",
        "november": "November",
        "december": "December",
        "month": "Month",
        "day": "Day",
        "year": "Year"
    },
    "email": "School Email Address",
    "emailConfirmation": "Confirm School Email Address",
    "emailExplanation": "Personal email address is recommended",
    "error": "Error",
    "firstName": "First Name",
    "howDoesReviewWork": "How does review work?",
    "howDoesVerifyingWork": "How does verifying work?",
    "lastName": "Last Name",
    "loading": "Loading...",
    "noOptions": "No options",
    "organization": "Name of School",
    "personalInformation": "Personal Information",
    "phoneNumber": "Phone number",
    "postalCode": "Postal code",
    "poweredBy": "Verification services powered by SheerID",
    "requiredFields": "All fields are required",
    "sheerIdFaqs": "SheerID FAQs",
    "status": "Status",
    "studentInfoShared": "Information entered into this web form will be used for verification purposes. The information will be shared with Headspace.<br><br>You can contact SheerID through our <a href=\"https://verify.sheerid.com/verification-support/feedback.html?token=\" class=\"sid-link\"  target=\"_blank\">Information Form<a/>. Someone from the SheerID Customer Service Team will respond as soon as they're able.<br><br>",
    "verifyMyTeacherStatus": "Verify and continue",
    "verificationPurposesOnly": "Used for verification purposes only",
    "limitExceededError": "Previously Submitted",
    "infoShared1": 'By clicking, I consent to processing my information for the purpose of verifying my eligibility as described within the {privacyPolicyLink}',
    "infoShared2": '. I understand that my information will be shared with Headpsace. ',
    "errorId": {
        "internalServerError": "Internal server error",
        "noProgram": "No program found",
        "noVerification": "No verification found",
        "invalidProgram": "Invalid program",
        "invalidStep": "Invalid step",
        "invalidMilitaryStatus": "Invalid military status, expected one of [ACTIVE_DUTY, VETERAN, RESERVIST, MILITARY_RETIREE]",
        "invalidFirstResponderStatus": "Invalid first responder status, expected one of [POLICE, EMT, FIREFIGHTER]",
        "invalidOrganization": "You must select an organization from the list",
        "invalidFirstName": "Invalid first name",
        "invalidLastName": "Invalid last name",
        "invalidBirthDate": "Invalid birth date",
        "invalidEmail": "Invalid email",
        "invalidEmailConfirmation": "Email does not match",
        "invalidPostalCode": "Invalid postal code",
        "underagePerson": "Underage",
        "outsideAgePerson": "Age outside allowed range",
        "futureBirthDate": "Future birthdate",
        "unsupportedDocMimeType": "One or more files is an unsupported format",
        "invalidFileSizeEmpty": "One or more files is empty",
        "invalidFileSizeMax": "One or more files is too large (max: 10MB)",
        "invalidNumberOfFiles": "Maximum number of files exceeded (max: 5)",
        "invalidDocUploadToken": "Provided document upload token is not valid",
        "verificationLimitExceeded": "A verification attempt has already been made with this email address. Please reach out to the SheerID Customer Service Team for your verification status and troubleshooting.",
        "docReviewLimitExceeded": "Document review limit exceeded",
        "maxMetadataValuesExceeded": "Maximum number of metadata values exceeded",
        "maxMetadataLengthExceeded": "Maximum length of metadata value exceeded",
        "unknownError": "Unknown Error",
        "invalidRequest": "Invalid request",
        "invalidApiToken": "Provided API token was invalid or empty",
        "simulatedError": "This is a simulated error",
        "notFound": "Not found"
    },
    "step": {
        "personalInfo": {
            "subtitle": "Before completeing the form below and continuing to the next page to confirm your eligibility, please prepare one of the following <a href=\"https://verify.sheerid.com/headspace-intl-teacher-faq/?pid=\" class=\"sid-link\" target=\"_blank\">accepted forms of identification</a>.",
            "title": "Verify your details",
            "howDoesVerifyingWorkDetails": "Headspace verifies Australian, Canadian and UK primary and secondary educators through our partner, SheerID. If you are a US K-12 educator, please find your district's state <a href=\"http://headspace.com/educators\" class=\"sid-link\"  target=\"_blank\">here</a>.",
            "tryAgain": {
                title: 'Check Your Name & Birthdate',
            },
            "countries": {
                "US": "United States"
            },
            "locales": {
                "en-US": "English"
            }
        },
        "docUpload": {
            "acceptedTypes": "File must be .jpg .png  .pdf .gif or .bmp",
            "title": "Upload documentation",
            "footer": null,
            "submitButtonLabel": "Continue",
            "uploadInstructions": "Upload your document that shows:",
            "acceptableExamples": "Acceptable examples include:",
            "estimatedWaitTime": "a few minutes",
            "howDoesVerifyingWorkDetails": `Document review is handled by SheerID, a trusted partner who specializes in verifying teachers.
                <br><br>
                Documents are used only for verifying your teacher or faculty status is current and will be permanently
                deleted after review is finalized. They will not be shared with Headspace`,
            "rejectionReasons": {
                "DOCUMENT_UNREADABLE": "The document you submitted was unreadable due to poor image quality. Please make sure you have a clearly legible image that's bright and crisp, and try submitting again.",
                "DOCUMENT_PASSWORD_PROTECTED": "We are unable to accept password protected documents.",
                "DOCUMENT_LIKELY_FRAUD": "The document you submitted is insufficient for establishing eligibility for this offer.",
                "DOCUMENT_UNSUPPORTED": "The document you submitted is not on the list of accepted document types.",
                "DOCUMENT_HANDWRITTEN": "We cannot accept handwritten documents.",
                "DOCUMENT_WORD_DOC": "We cannot accept text copied and pasted from official documents. Please submit a screenshot or image of the official document.",
                "MISSING_INFORMATION": "The document you submitted does not provide all of the information necessary to determine eligibility for this offer.",
                "MISSING_INFORMATION_PERSON_NAME": "The document you submitted is missing a first and/or last name.",
                "MISSING_INFORMATION_ORGANIZATION_NAME": "The document you submitted does not include an organization name that confirms your connection to that organization.",
                "DOCUMENT_EXPIRED": "The document you submitted has expired.",
                "DOCUMENT_OUTDATED": "The document you submitted is missing an issue date or was issued too far in the past.",
                "DOCUMENT_OUTDATED_LAST_3_MONTHS": "The document you submitted is missing an issue date or was issued more than three months ago.",
                "DOCUMENT_OUTDATED_LAST_6_MONTHS": "The document you submitted is missing an issue date or was issued more than six months ago.",
                "DOCUMENT_OUTDATED_LAST_12_MONTHS": "The document you submitted is missing an issue date or was issued more than twelve months ago.",
                "MISMATCH_PERSON_NAME": "The information on the document you submitted does not match the first and/or last name submitted on the verification form.",
                "MISMATCH_ORGANIZATION": "The organization name on the document(s) you submitted does not match the organization you listed on the verification form.",
                "MISMATCH_STATUS": "The status on the document you submitted does not match the status you listed on your verification form.",
                "INELIGIBLE_ORGANIZATION": "The organization on the document you submitted is not eligible for this offer.",
                "MISSING_INFORMATION_UNIVERSITY_ENROLLMENT": "The document you submitted does not prove enrollment in the current term.",
                "MISMATCH_SCHOOL_NAME": "The school name on the document you submitted does not match the school name listed on the verification form.",
                "INELIGIBLE_ORGANIZATION_UNIVERSITY_TITLE_IV": "The school listed on the document you submitted is not eligible for this offer because it is not a Title IV degree-granting college or university in the United States.",
                "INELIGIBLE_ORGANIZATION_US_UNIVERSITY": "The school listed in the document you submitted is not eligible for this offer because it is not in the United States.",
                "INELIGIBLE_PERSON_HIGH_SCHOOL_STUDENT": "High School Students are not eligible for this offer.",
                "MISSING_INFORMATION_AFFILIATION_US_ARMED_FORCES": "The document you submitted is does not show affiliation to an eligible branch of the United States Armed Forces.",
                "MISSING_INFORMATION_AFFILIATION_US_UNIFORMED_SERVICES": "The document you submitted does not show affiliation to an eligible branch of the United States Uniformed Services.",
                "MISMATCH_COMPANY_NAME": "The company name on the document you submitted does not match the company name you listed on the verification form.",
                "PAYSTUB_OUTDATED_LAST_30_DAYS": "Please upload a paystub that was issued within the last 30 days.",
                "PAYSTUB_OUTDATED_LAST_60_DAYS": "Please upload a paystub that was issued within the last 60 days.",
                "MISSING_INFORMATION_BIRTHDATE": "The document you submitted is missing a birthdate, or your age is ineligible for this offer.",
                "MISMATCH_BIRTHDATE": "The birthdate on the document you submitted does not match the birthdate you listed on the verification form.",
                "OTHER_CONTACT_US": "We are having problems verifying your eligibility for the offer. Please contact SheerID customer service for help: customerservice@sheerid.com",
                "PERSON_FIELD_MISMATCH": "A field in the document provided did not match with what was provided on the verification form."
            }
        },
        "pending": {
            "subtitle": "Your document has been uploaded successfully. The review process has now started. You will be contacted via email within 3 days with details regarding your verification request.",
            "title": "Processing",
            "titleReview": "Upload success",
            "subtitle2": "NOTE: If you do not receive an email within the time shown above, you may want to check your junk/spam folder for the message. Please reach out to the SheerID Customer Service Team for verification status and troubleshooting.",
            "subtitle3": "",
            "maxReviewTime": "3 days"
        },
        "success": {
            "title": "Success. You've been verified.",
            "subtitle": 'Here is your coupon code that can only be redeemed once for an annual Headspace Plus subscription at <a href="https://www.headspace.com/code" class="sid-link" target="_blank">www.headspace.com/code</a>:',
            "redirectUrl": null,
            "redirectButtonText": "Continue",
            "emailNotification": "After entering your code, you will have the option to sign up for a new Headspace account or log in to an existing Headspace account. The coupon code cannot be combined with any other offer or promotion.<br><br>To make sure you have every opportunity to redeem your code, we’re also emailing you the details above from verify@sheerid.com.",
            "verificationOnly": `
            SheerID handles verification only.
            Now that you've been approved, please direct all questions about the
            promotion terms and/or code use to Headspace customer service.
        `,
        }
    }
};
